export type SupportPortalNavTab = "companies" | "contacts"

export const supportPortalPath = (tab: SupportPortalNavTab, id: string) =>
	tab === "companies"
		? `/support-portal/${id}`
		: `/support-portal/contact/${id}`

// Arrow up/down wraps around the visible list; nothing selected starts at the
// end the arrow points from.
export const getNavTarget = ({
	items,
	selectedId,
	offset,
	tab,
}: {
	items: Array<{ id: string }>
	selectedId?: string
	offset: number
	tab: SupportPortalNavTab
}): string | null => {
	if (items.length === 0) return null
	const currentIndex = items.findIndex((item) => item.id === selectedId)
	const nextIndex =
		currentIndex === -1
			? offset > 0
				? 0
				: items.length - 1
			: (currentIndex + offset + items.length) % items.length
	const next = items[nextIndex]
	return next ? supportPortalPath(tab, next.id) : null
}

// A row shows the email on its own line, so a search hit on an address the name
// hides is visible. Nameless contacts keep the email as their only line.
export const getContactRowLabels = (contact: {
	name?: string | null
	email: string
}): { primary: string; secondary: string | null } => {
	const name = contact.name?.trim()
	if (!name || name === contact.email) {
		return { primary: contact.email, secondary: null }
	}
	return { primary: name, secondary: contact.email }
}
